import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Anchor } from 'components/base';
import { PrismicHtmlContent } from 'components/rich';
import BaseTopBanner from 'components/layout/topBanner';
import useDataContext from 'data/context/data';

const TopBanner = forwardRef((props, ref) => {
  const dataContext = useDataContext();

  if (dataContext.banner) {
    return (
      <BaseTopBanner ref={ref} visible={props.visible} onVisibleChange={props.onVisibleChange}>
        <PrismicAnchor banner={dataContext.banner} />
      </BaseTopBanner>
    );
  }

  return null;
});

TopBanner.propTypes = {
  visible: PropTypes.bool,
  onVisibleChange: PropTypes.func,
};

const PrismicAnchor = props => {
  const { url, text } = props.banner;

  const children = <PrismicHtmlContent content={text} />;

  if (url) {
    return (
      <Anchor href={url.url || '/'} className="text-white">
        {children}
      </Anchor>
    );
  }

  return <div className="text-white">{children}</div>;
};

PrismicAnchor.propTypes = {
  banner: PropTypes.object,
};

export default TopBanner;
